// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledLink from '../../../../product/shared/components/labeled-link';
import LabeledString from '../../../../shared/components/labeled-string';
import PipDetails from '@deere/cps-it.warranty-model-factory/lib/pip-details';
import PipRequiredItems from '../../../../pip/pip-details/components/pip-required-items';
import {buildDate} from '../../../../shared/services/build-date';

const PipDetailsPanel = props =>
    <div className='pip-details-panel'>
        <div className='pip-details'>
            <header>
                <a
                    href={`#/pips/programs/${props.pipDetails.pipId}`}
                    rel='noopener noreferrer'
                    target='_blank'
                >
                    {props.pipDetails.description}
                </a>
            </header>
            <LabeledLink
                className='pip-type'
                data={props.pipDetails.pipNumber}
                href={`#/pips/programs/${props.pipDetails.pipId}`}
                label='PROGRAM_NUMBER'
                rel='noopener noreferrer'
                target='_blank'
            />
            <LabeledString
                className='pip-type'
                data={props.pipDetails.pipType.value}
                label='PIP_TYPE'
            />
            <LabeledLink
                className='dtac-solution'
                data={props.pipDetails.dtac}
                href={props.pipDetails.dtacUrl}
                label='DTAC_SOLUTION'
                rel='noopener noreferrer'
                target='_blank'
            />
            <LabeledString
                className='pip-status'
                data={props.pipDetails.pipStatus.value}
                label='PIP_STATUS'
            />
            <LabeledString
                className='expiry-date'
                data={buildDate(props.pipDetails.expireDate)}
                label='EXPIRES'
            />
            <LabeledString
                className='terminates'
                data={buildDate(props.pipDetails.terminationDate)}
                label='TERMINATES'
            />
            <LabeledString
                className='metric'
                data={props.pipDetails.metric.value}
                label='METRIC'
            />
        </div>
        <PipRequiredItems requiredItems={props.pipDetails.requiredItems}/>
        <div className='special-instructions'>
            <header>
                <FormattedMessage id='SPECIAL_INSTRUCTIONS'/>
            </header>
            {props.pipDetails.specialInstructions ?
                props.pipDetails.specialInstructions :
                <FormattedMessage id='NO_SPECIAL_INSTRUCTIONS'/>
            }
        </div>
    </div>;

PipDetailsPanel.displayName = 'PipDetailsPanel';
PipDetailsPanel.propTypes = {
    pipDetails: PropTypes.instanceOf(PipDetails).isRequired
};

export default PipDetailsPanel;



// WEBPACK FOOTER //
// ./src/claim/pip/components/pip-details-panel/index.js